<template>
    <div class="payment-chart-table">
        <button class="btn btn-blue amortization-table-btn" @click="toggleAmortizationTable()">
            {{ AmortizationTableVisible ? "Close" : "View" }} Amortization Table
        </button>
        <div v-show="AmortizationTableVisible" class="table-responsive">
            <table
                v-for="(yearData, year) in amortizationBreakdown" :key="year" class="table"
                :class="{active: isActive[year]}">
                <thead>
                    <tr>
                        <th width="20%">
                            <label class="table-trigger" @click="toggleActive(year)">
                                <span class="lt4-ChevronRight"></span> {{ year }}
                            </label>
                        </th>
                        <th width="16%">
                            <big>Payment</big>
                        </th>
                        <th width="16%">
                            <big>Principal</big>
                        </th>
                        <th width="16%">
                            <big>Interest Paid</big>
                        </th>
                        <th width="16%">
                            <big>Total Interest</big>
                        </th>
                        <th width="16%">
                            <big>Balance</big>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(monthData, index) in yearData" :key="index">
                        <td>{{ monthData.namedMonth }}</td>
                        <td>${{ currencyFilter(monthData.payment) }}</td>
                        <td>${{ currencyFilter(monthData.principal) }}</td>
                        <td>${{ currencyFilter(monthData.interestPaid) }}</td>
                        <td>${{ currencyFilter(monthData.totalInterest) }}</td>
                        <td>${{ currencyFilter(monthData.balance) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import Accounting from 'accounting';

    export default {
        props: {
            showAmortizationTable: {
                default: true,
            },
            amortizationBreakdown: {
                default: [],
            },
        },
        data() {
            return {
                isActive: {},
                AmortizationTableVisible: this.showAmortizationTable,
            };
        },
        computed: {
            AmortizationTable() {
                return this.amortizationBreakdown;
            },
        },
        methods: {
            toggleAmortizationTable() {
                this.AmortizationTableVisible = !this.AmortizationTableVisible;
            },
            toggleActive(year) {
                this.isActive[year] = !this.isActive[year];
            },
            currencyFilter(figure) {
                return Accounting.formatNumber(figure, { precision: 2 });
            },
        },
        mounted() {
            this.isActive[Object.keys(this.AmortizationTable)[0]] = true;
        },
        mixins: [Accounting],
    };
</script>
<style lang="scss" src="../../assets/styles/amortization-breakdown-table.scss"></style>
